<template>
    <el-select v-model="inputvalue"
			   :multiple="multiple"
			   :collapse-tags="collapseTags"
               :popper-append-to-body="popperAppendToBody"
               :class="classname"
               :placeholder="$t('LnkLov.placeholder')"
               size="mini"
               :clearable="clearable"
               :filterable="filterable"
			   :disabled="disabled"
			   @change="setStatus">
        <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name" :value="item.val"
        ></el-option>
    </el-select>
</template>

<script>
export default {
    name: 'lnk-lov',
    data() {
        return {
            options: [],
            inputvalue: ''
        };
    },
    props: {
      	collapseTags: Boolean, // 是否折叠标签
      	multiple: Boolean, // 是否多选
        lov: String, // 值列表的类型
        excludeLov: Array, // 排除的值列表
        popperAppendToBody: {
            type: Boolean,
            default(){
                return true;
            }
        },
        parentLovType: String,
        parentLovValue: String, //父值列表的独立源代码
        value1: String, // 外部传输的值
        clearable: Boolean, // 是否可清空
        filterable: Boolean, // 可否搜索
        classname: String, // class加类名
        disabled: Boolean // 是否禁用
    },
    model: {
        prop: 'value1',
        event: 'innerChange'
    },
    mounted() {
        this.getstatus();
        if (this.value1 !== undefined) {
          if (this.multiple) {
            const list = JSON.parse(this.value1);
            this.inputvalue = list
		  } else {
            this.inputvalue = this.value1;
		  }
        }

    },
    watch: {
        value1: {
            immediate: true,
            handler: function (newVal) {
              if(newVal) {
                if(this.multiple) {
                  const list = JSON.parse(newVal);
                  this.inputvalue = list
				} else {
                  this.inputvalue = newVal;
				}
			  } else {
                this.inputvalue = this.multiple ? [] : ''
			  }
            }
        },
        // 值列表相关数据发生变化，清空已选中的值
        parentLovType(){
            this.$emit('innerChange', '');
            this.getstatus();
        },
        parentLovValue(val, oldVal) {
            if (oldVal) {
                this.$emit('innerChange', '');
            }
            this.getstatus();
        },
        lov(){
            this.$emit('innerChange', '');
            this.getstatus();
        }
    },
    methods: {
        setStatus(val) {
          if (this.multiple) {
            // 如果是多选
            if(val && val.length) {
              const result = JSON.stringify(val);
              // 返回修改v-model值，字符串类型
              this.$emit('innerChange', result);
              // change 事件返回数组
              this.$emit('change', val);
			} else {
              // 返回修改v-model值，字符串类型
              this.$emit('innerChange', '[]');
              // change 事件返回数组
              this.$emit('change', []);
			}
		  } else {
            // 单选
            // 回传取到的值
            this.$emit('innerChange', this.inputvalue);
            for (let i = 0; i < this.options.length; i++) {
              if (this.inputvalue === this.options[i].val) {
                this.$emit('setlovvalue', JSON.stringify(this.options[i]));
                this.$emit('change', val);
                return;
              }
            }
            this.$emit('change', '');
            this.$emit('setlovvalue', '');
		  }

        },
        async getstatus() {
            // this.options = linkLov.getLovArray(this.lov);
            // 获取值列表
            const {lovs, defaultVal} = await this.$lov.getLovData(this.lov, this.parentLovType, this.parentLovValue, this.excludeLov, false)
            this.options = lovs
            if (!this.value1 && !!defaultVal) {
              if(this.multiple) {
                // 多选
                this.inputvalue = [defaultVal]
                this.$emit('innerChange', JSON.stringify([defaultVal]));
			  } else {
                // 单选
                this.inputvalue = defaultVal;
                this.$emit('innerChange', this.inputvalue);
			  }
            }
        }
    }
};
</script>

<style scoped>

</style>
